import { FileLock2 } from "lucide-react";
import { PayrollHistory } from "../components/payroll/PayrollHistory";

export default function MyPayslipsPage() {
  return <div className="p-4 lg:p-8 max-w-4xl w-full min-w-0 mx-auto pb-24" data-testid="my-payslips-page">
    <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2 mb-2" data-testid="my-payslips-title"><FileLock2 size={24} className="shrink-0 text-[#26788A]" />Mes bulletins de salaire</h1>
    <p className="text-sm text-slate-500 mb-7" data-testid="my-payslips-privacy">Votre espace personnel et confidentiel.</p>
    <PayrollHistory />
  </div>;
}